import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { FormProvider } from 'react-hook-form';

var Container = function (_a) {
    var children = _a.children, onSubmit = _a.onSubmit, methods = _a.methods;
    return (React.createElement(FormProvider, __assign({}, methods),
        React.createElement("form", { onSubmit: function (e) {
                methods.handleSubmit(function (data) { return onSubmit(data, e); })(e);
            } }, children)));
};

export { Container };
//# sourceMappingURL=Container.js.map
